export const isSearchPage = () => {
  return new RegExp('^https://.*/[a-zA-Z-]+/(search)/.*').test(window.location.href)
}
